export default {
  receipts: [],
  receipt: {}
}



// WEBPACK FOOTER //
// ./src/components/receipt/store/state.js